import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const caseRequestInfoValidation = Yup.object({
  workStartDate: Yup.string().required(messages.MANDATORY_FIELD),
  requestAmendment: Yup.object().required(messages.MANDATORY_FIELD),
  numberOfDaysToSolve: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  requestName: Yup.string().required(messages.MANDATORY_FIELD),
  requestFileNumber: Yup.string().required(messages.MANDATORY_FIELD),
  requestCompletionDate: Yup.string().required(messages.MANDATORY_FIELD),
  solutionDeadlineDate: Yup.string().required(messages.MANDATORY_FIELD),
});
